const prepareJsx = ({ originalJsx }) => {
  let jsx = originalJsx || '';
  jsx = jsx.replace(/ frameborder/g, ' frameBorder');
  jsx = jsx.replace(/ allowfullscreen/g, ' allowFullScreen');
  jsx = jsx.replace(/webkitallowfullscreen(?!=)/g, 'webkitallowfullscreen="true"');
  jsx = jsx.replace(/mozallowfullscreen(?!=)/g, 'mozallowfullscreen="true"');
  return jsx;
};

export default prepareJsx;
